import proptypes from 'prop-types';

const {
  arrayOf, bool, shape, string, func
} = proptypes;

export const propTypes = {
  collection: shape({
    collectionId: string,
    curations: arrayOf(string),
    metadata: shape({
      name: string
    })
  }).isRequired,
  preview: bool,
  spaceCollectionId: string.isRequired,
  skipFn: func.isRequired,
  storeId: string.isRequired
};

export const defaultProps = {
  preview: false
};
